import { Text } from 'pixi.js';
import { Scene } from '../core/Scene';
import { GAME_WIDTH, GAME_HEIGHT } from '../constants';

export class EndGameScene extends Scene {
  constructor() {
    super();

    const text = new Text({
      text: 'Game Complete',
      style: { fill: 0xffffff, fontSize: 64, fontFamily: 'monospace' },
    });
    text.anchor.set(0.5);
    text.x = GAME_WIDTH / 2;
    text.y = GAME_HEIGHT / 2;
    this.container.addChild(text);
  }

  enter(): void {
    // nothing to set up
  }

  update(_deltaTime: number): void {
    // nothing to update
  }

  exit(): void {
    // nothing to clean up
  }
}
